module.exports = __webpack_public_path__ + "img/1f430.698add3.svg";